import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-bp.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-bp.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { CreateApplicationDetailsBpConstants } from "./create-application-details-bp.constants";
import { take, takeUntil } from "rxjs/operators";
import { BuildingPlansService } from "../../../../../shared/services/modules/building-plans.service";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
import { AlertType } from "../../../../../shared/models/alert";
import { AppConfig } from "../../../../../app.config";
let CreateApplicationDetailsBpComponent = class CreateApplicationDetailsBpComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    appController;
    changeDetectorRefs;
    buildingPlansService;
    componentName = CreateApplicationDetailsBpConstants.COMPONENT_NAME;
    detailsForm;
    detailsFormGroupName = CreateApplicationDetailsBpConstants.DETAILS_FORM_GROUP_NAME;
    validationMessages = CreateApplicationDetailsBpConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    verificationMessage = CreateApplicationDetailsBpConstants.RESUBMISSION_VERIFICATION_MESSAGE;
    sectorOptionsLookupName = CreateApplicationDetailsBpConstants.SECTOR_OPTION_LOOKUP_NAME;
    buildingUseOptionsLookupName = CreateApplicationDetailsBpConstants.BUILDING_USE_OPTION_LOOKUP_NAME;
    nonResidentialBuildingUseLookupName = CreateApplicationDetailsBpConstants.NON_RESIDENTIAL_BUILDING_USE_OPTION_LOOKUP_NAME;
    residentialBuildingUseLookupName = CreateApplicationDetailsBpConstants.RESIDENTIAL_BUILDING_USE_OPTION_LOOKUP_NAME;
    typeOptionsLookupName = CreateApplicationDetailsBpConstants.TYPE_OPTION_LOOKUP_NAME;
    estimatedByOptionsLookupName = CreateApplicationDetailsBpConstants.ESTIMATED_BY_OPTION_LOOKUP_NAME;
    descriptionLabel = CreateApplicationDetailsBpConstants.DESCRIPTION_LABEL;
    isMinorBuildingWorkLabel = CreateApplicationDetailsBpConstants.IS_MINOR_BUILDING_WORK_LABEL;
    isResidentialApplicationLabel = CreateApplicationDetailsBpConstants.IS_RESIDENTIAL_APPLICATION_LABEL;
    otherBuildingUseLabel = CreateApplicationDetailsBpConstants.OTHER_BUILDING_USE_LABEL;
    isAlterationsLabel = CreateApplicationDetailsBpConstants.IS_ALTERATIONS_LABEL;
    sectorLabel = CreateApplicationDetailsBpConstants.SECTOR_LABEL;
    isRDPLabel = CreateApplicationDetailsBpConstants.IS_RDP_LABEL;
    buildingUseLabel = CreateApplicationDetailsBpConstants.BUILDING_USE_LABEL;
    applicationTypeLabel = CreateApplicationDetailsBpConstants.APPLICATION_TYPE_LABEL;
    estimatedByLabel = CreateApplicationDetailsBpConstants.APPLICATION_ESTIMATED_BY_LABEL;
    estimatedCostLabel = CreateApplicationDetailsBpConstants.APPLICATION_ESTIMATED_COST_LABEL;
    previousReferenceNumberLabel = CreateApplicationDetailsBpConstants.PREVIOUS_REFERENCE_NUMBER_LABEL;
    isResubmissionLabel = CreateApplicationDetailsBpConstants.IS_RESUBMISSION_LABEL;
    isExtensionLabel = CreateApplicationDetailsBpConstants.IS_EXTENSION_LABEL;
    verifyLabel = CreateApplicationDetailsBpConstants.VERIFY_LABEL;
    descriptionFormControlName = CreateApplicationDetailsBpConstants.DESCRIPTION_FORM_CONTROL_NAME;
    buildingPlanNumberFormControlName = CreateApplicationDetailsBpConstants.BUILDING_PLAN_NUMBER_FORM_CONTROL_NAME;
    isMinorBuildingWorkFormControlName = CreateApplicationDetailsBpConstants.IS_MINOR_BUILDING_WORK_FORM_CONTROL_NAME;
    isResidentialApplicationFormControlName = CreateApplicationDetailsBpConstants.IS_RESIDENTIAL_APPLICATION_CONTROL_NAME;
    isAlterationsFormControlName = CreateApplicationDetailsBpConstants.IS_ALTERATIONS_CONTROL_NAME;
    isBuildingUseOtherFormControlName = CreateApplicationDetailsBpConstants.IS_BUILDING_USE_OTHER_CONTROL_NAME;
    buildingTypeFormControlName = CreateApplicationDetailsBpConstants.BUILDING_TYPE_CONTROL_NAME;
    sectorFormControlName = CreateApplicationDetailsBpConstants.SECTOR_FORM_CONTROL_NAME;
    isRDPFormControlName = CreateApplicationDetailsBpConstants.IS_RDP_FORM_CONTROL_NAME;
    buildingUseFormControlName = CreateApplicationDetailsBpConstants.BUILDING_USE_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsBpConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    estimatedByFormControlName = CreateApplicationDetailsBpConstants.APPLICATION_ESTIMATED_BY_FORM_CONTROL_NAME;
    estimatedCostFormControlName = CreateApplicationDetailsBpConstants.APPLICATION_ESTIMATED_COST_FORM_CONTROL_NAME;
    previousReferenceNumberFormControlName = CreateApplicationDetailsBpConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    isResubmissionFormControlName = CreateApplicationDetailsBpConstants.IS_RESUBMISSION_FORM_CONTROL_NAME;
    isExtensionFormControlName = CreateApplicationDetailsBpConstants.IS_EXTENSION_FORM_CONTROL_NAME;
    yesNoOptions = [];
    sectorOptions = [];
    buildingUseOptions = [];
    nonResidentialBuildingUseOptions = [];
    residentialBuildingUseOptions = [];
    applicationTypeOptions = [];
    estimatedByOptions = [];
    isResubmissionOptions = [];
    isExtensionOptions = [];
    acceptFormControlLabel = CreateApplicationDetailsBpConstants.ACCEPT_LABEL;
    acceptFormControlName = CreateApplicationDetailsBpConstants.ACCEPT_FORM_CONTROL_NAME;
    titleLabelMessage = CreateApplicationDetailsBpConstants.RESUBMISSION_DISCLAIMER_TITLE;
    contentLabelMessage = CreateApplicationDetailsBpConstants.RESUBMISSION_DISCLAIMER_CONTENT;
    supportResubmissions = false;
    isResubmission = false;
    isVerified = false;
    showDetails = true;
    showBuildingTypeField = false;
    resubmissionDisclaimerTitle = "";
    resubmissionDisclaimerContent = "";
    acceptResubmissionDisclaimer = false;
    supportExtensions = true;
    isExtension = false;
    showResubmission = false;
    showVerify = false;
    constructor(createApplicationService, aflaModuleStrategyService, appController, changeDetectorRefs, buildingPlansService) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.buildingPlansService = buildingPlansService;
        if (AppConfig.settings) {
            this.resubmissionDisclaimerTitle = AppConfig.settings.resubmissionDisclaimer.bp.title;
            this.resubmissionDisclaimerContent = AppConfig.settings.resubmissionDisclaimer.bp.content;
            if (this.resubmissionDisclaimerTitle === "") {
                this.resubmissionDisclaimerTitle = this.titleLabelMessage;
            }
            if (this.resubmissionDisclaimerContent === "") {
                this.resubmissionDisclaimerContent = this.contentLabelMessage;
            }
        }
    }
    ngOnInit() {
        this.initForm();
        if (this.appController.moduleSimulateMode) {
            const defaults = SimulationUtils.simulate_Create_Application();
            this.isExtensionOptions = defaults.simulateExtendApplicationOptions;
            this.isResubmissionOptions = defaults.simulateExtendApplicationOptions;
            this.supportExtensions = false;
            this.supportResubmissions = false;
            this.applicationTypeOptions = defaults.applicationType;
            this.buildingUseOptions = defaults.buildingUse;
            this.nonResidentialBuildingUseOptions = defaults.buildingUse;
            this.residentialBuildingUseOptions = defaults.buildingUse;
            this.sectorOptions = defaults.sector;
            this.estimatedByOptions = defaults.estimatedBy;
            this.yesNoOptions = Object.values(SharedConstants.YES_NO_ENUM);
        }
        else {
            if (this.aflaModuleStrategyService.lookups.has(this.sectorOptionsLookupName) &&
                this.aflaModuleStrategyService.lookups.get(this.buildingUseOptionsLookupName) &&
                this.aflaModuleStrategyService.lookups.get(this.typeOptionsLookupName) &&
                this.aflaModuleStrategyService.lookups.get(this.estimatedByOptionsLookupName)) {
                this.sectorOptions = this.aflaModuleStrategyService.lookups.get(this.sectorOptionsLookupName);
                this.buildingUseOptions = this.aflaModuleStrategyService.lookups.get(this.buildingUseOptionsLookupName);
                this.applicationTypeOptions = this.aflaModuleStrategyService.lookups.get(this.typeOptionsLookupName);
                this.estimatedByOptions = this.aflaModuleStrategyService.lookups.get(this.estimatedByOptionsLookupName);
                this.yesNoOptions = Object.values(SharedConstants.YES_NO_ENUM);
                this.isResubmissionOptions = [];
                this.isResubmissionOptions = [
                    { code: SharedConstants.YES_NO_ENUM.Yes, value: SharedConstants.YES_NO_ENUM.Yes },
                    { code: SharedConstants.YES_NO_ENUM.No, value: SharedConstants.YES_NO_ENUM.No }
                ];
                this.isExtensionOptions = [];
                this.isExtensionOptions = [
                    { code: SharedConstants.YES_NO_ENUM.Yes, value: SharedConstants.YES_NO_ENUM.Yes },
                    { code: SharedConstants.YES_NO_ENUM.No, value: SharedConstants.YES_NO_ENUM.No }
                ];
            }
            else {
                this.getLookups();
            }
            this.getMetadata();
        }
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(this.detailsFormGroupName);
        this.initialiseBuildingUseFields();
    }
    loadMetadata(stepMeta) {
        if (stepMeta.extensionOptions !== undefined && stepMeta.extensionOptions !== null) {
            this.supportExtensions = stepMeta.extensionOptions.enabled;
        }
        if (this.appController.moduleAllowResubmission) {
            this.supportResubmissions = true;
        }
        else {
            this.supportResubmissions = false;
        }
        if (this.supportResubmissions && this.supportExtensions) {
            this.showDetails = false;
            this.showResubmission = false;
        }
        else if (!this.supportResubmissions && !this.supportExtensions) {
            this.showDetails = true;
            this.showResubmission = false;
            this.showVerify = false;
        }
        else if (this.supportResubmissions && !this.supportExtensions) {
            this.showDetails = false;
            this.showResubmission = true;
        }
        else if (!this.supportResubmissions && this.supportExtensions) {
            this.showDetails = false;
            this.showResubmission = false;
        }
        if (this.detailsForm.get(this.isExtensionFormControlName).value !== null) {
            const element = this.detailsForm.get(this.isExtensionFormControlName).value;
            if (element === SharedConstants.YES_NO_ENUM.Yes) {
                this.isExtension = true;
                this.showVerify = true;
                this.showResubmission = false;
                this.showDetails = true;
            }
            else {
                if (this.detailsForm.get(this.isResubmissionFormControlName).value !== null) {
                    const element = this.detailsForm.get(this.isResubmissionFormControlName).value;
                    if (element === SharedConstants.YES_NO_ENUM.Yes) {
                        this.showResubmission = true;
                        this.isResubmission = true;
                        this.showVerify = true;
                        this.showDetails = true;
                        if (this.detailsForm.get("verified").value !== null && this.detailsForm.get("verified").value === true) {
                            this.isVerified = true;
                        }
                    }
                    else {
                        this.isResubmission = false;
                        this.showDetails = true;
                    }
                }
            }
        }
        this.changeDetectorRefs.detectChanges();
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.createApplicationService.moduleID} and (name eq 'ResidentialBuildingUse' or name eq 'NonResidentialBuildingUse' or name eq 'BuildingSector' or name eq 'ApplicationType' or name eq 'PropertyEstimatedBy' and deleted eq false)`,
        };
        this.createApplicationService
            .getLookupsObservable(params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsBpConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const nonResidentialBuildingUse = [];
        const residentialBuildingUse = [];
        const sector = [];
        const applicationType = [];
        const estimatedBy = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "NonResidentialBuildingUse") {
                    nonResidentialBuildingUse.push(JSON.parse(item.content));
                }
                if (item.name === "ResidentialBuildingUse") {
                    residentialBuildingUse.push(JSON.parse(item.content));
                }
                if (item.name === "BuildingSector") {
                    sector.push(JSON.parse(item.content));
                }
                if (item.name === "ApplicationType") {
                    applicationType.push(JSON.parse(item.content));
                }
                if (item.name === "PropertyEstimatedBy") {
                    estimatedBy.push(JSON.parse(item.content));
                }
            });
        }
        nonResidentialBuildingUse.sort((a, b) => a.value.localeCompare(b.value));
        residentialBuildingUse.sort((a, b) => a.value.localeCompare(b.value));
        sector.sort((a, b) => a.value.localeCompare(b.value));
        applicationType.sort((a, b) => a.value.localeCompare(b.value));
        estimatedBy.sort((a, b) => a.value.localeCompare(b.value));
        this.yesNoOptions = [];
        this.yesNoOptions = Object.values(SharedConstants.YES_NO_ENUM);
        this.isExtensionOptions = [{ code: "true", value: SharedConstants.YES_NO_ENUM.Yes }, { code: "false", value: SharedConstants.YES_NO_ENUM.No }];
        this.isResubmissionOptions = [{ code: "true", value: SharedConstants.YES_NO_ENUM.Yes }, { code: "false", value: SharedConstants.YES_NO_ENUM.No }];
        this.aflaModuleStrategyService.lookups.set(this.nonResidentialBuildingUseLookupName, nonResidentialBuildingUse);
        this.nonResidentialBuildingUseOptions = nonResidentialBuildingUse;
        this.aflaModuleStrategyService.lookups.set(this.residentialBuildingUseLookupName, residentialBuildingUse);
        this.residentialBuildingUseOptions = residentialBuildingUse;
        this.aflaModuleStrategyService.lookups.set(this.sectorOptionsLookupName, sector);
        this.sectorOptions = sector;
        this.aflaModuleStrategyService.lookups.set(this.typeOptionsLookupName, applicationType);
        this.applicationTypeOptions = applicationType;
        this.aflaModuleStrategyService.lookups.set(this.estimatedByOptionsLookupName, estimatedBy);
        this.estimatedByOptions = estimatedBy;
        this.changeDetectorRefs.detectChanges();
    }
    onIsExtensionChanged(event) {
        const element = event.target?.value;
        this.aflaModuleStrategyService.previousApplication = null;
        this.aflaModuleStrategyService.resetForm();
        this.aflaModuleStrategyService.form.get("propertiesForm").get("properties").clear();
        if (element === SharedConstants.YES_NO_ENUM.Yes) {
            this.detailsForm.get(this.isExtensionFormControlName).setValue(SharedConstants.YES_NO_ENUM.Yes);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValidators([Validators.required]);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).enable();
            this.detailsForm.get("acceptDisclaimer").clearValidators();
            this.detailsForm.get("acceptDisclaimer").setValue(null);
            this.isExtension = true;
            this.isResubmission = false;
            this.isVerified = false;
            this.showResubmission = false;
            this.showDetails = false;
            this.showVerify = true;
            this.acceptResubmissionDisclaimer = false;
        }
        else {
            this.detailsForm.get(this.isExtensionFormControlName).setValue(SharedConstants.YES_NO_ENUM.No);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).clearValidators();
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).disable();
            this.detailsForm.get("acceptDisclaimer").clearValidators();
            this.detailsForm.get("acceptDisclaimer").setValue(null);
            this.isExtension = false;
            this.isResubmission = false;
            this.acceptResubmissionDisclaimer = false;
            if (this.supportResubmissions === false) {
                this.showResubmission = false;
                this.showDetails = true;
            }
            else {
                this.showResubmission = true;
                this.showDetails = false;
            }
            this.isVerified = false;
            this.showVerify = false;
        }
        this.detailsForm.get("verified").setValue(this.isVerified);
        this.detailsForm.get("acceptDisclaimer").updateValueAndValidity();
        this.detailsForm.get(this.previousReferenceNumberFormControlName).updateValueAndValidity();
        this.detailsForm.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onIsResubmissionChanged(event) {
        const element = event.target?.value;
        this.aflaModuleStrategyService.previousApplication = null;
        this.aflaModuleStrategyService.resetForm();
        this.aflaModuleStrategyService.form.get("propertiesForm").get("properties").clear();
        if (element === SharedConstants.YES_NO_ENUM.Yes) {
            this.detailsForm.get(this.isExtensionFormControlName).setValue(SharedConstants.YES_NO_ENUM.No);
            this.detailsForm.get(this.isResubmissionFormControlName).setValue(SharedConstants.YES_NO_ENUM.Yes);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValidators([Validators.required]);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).enable();
            this.detailsForm.get("acceptDisclaimer").setValidators([Validators.required]);
            this.detailsForm.get("acceptDisclaimer").setValue(null);
            this.isExtension = false;
            this.isResubmission = true;
            this.isVerified = false;
            this.showDetails = false;
            this.showVerify = true;
            this.acceptResubmissionDisclaimer = false;
        }
        else {
            this.detailsForm.get(this.isExtensionFormControlName).setValue(SharedConstants.YES_NO_ENUM.No);
            this.detailsForm.get(this.isResubmissionFormControlName).setValue(SharedConstants.YES_NO_ENUM.No);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).clearValidators();
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).disable();
            this.detailsForm.get("acceptDisclaimer").clearValidators();
            this.detailsForm.get("acceptDisclaimer").setValue(null);
            this.isExtension = false;
            this.isResubmission = false;
            this.isVerified = false;
            this.showDetails = true;
            this.showVerify = false;
            this.acceptResubmissionDisclaimer = false;
        }
        this.detailsForm.get("verified").setValue(this.isVerified);
        this.detailsForm.get("acceptDisclaimer").updateValueAndValidity();
        this.detailsForm.get(this.previousReferenceNumberFormControlName).updateValueAndValidity();
        this.detailsForm.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    resetVerification() {
        this.aflaModuleStrategyService.previousApplication = null;
        this.isVerified = false;
        this.showDetails = false;
        this.acceptResubmissionDisclaimer = false;
        const previousReferenceNumber = this.detailsForm.get(this.previousReferenceNumberFormControlName).value;
        this.detailsForm.get(this.descriptionFormControlName).reset();
        this.detailsForm.get("verified").setValue(false);
        if (this.isExtension || this.isResubmission) {
            /*       this.detailsForm.get(this.isExtensionFormControlName).setValue(SharedConstants.YES_NO_ENUM.No);
                  this.detailsForm.get(this.isResubmissionFormControlName).setValue(SharedConstants.YES_NO_ENUM.No); */
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValidators([Validators.required]);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(previousReferenceNumber);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).enable();
        }
        else {
            /*       this.detailsForm.get(this.isExtensionFormControlName).setValue(SharedConstants.YES_NO_ENUM.No);
                  this.detailsForm.get(this.isResubmissionFormControlName).setValue(SharedConstants.YES_NO_ENUM.No); */
            this.detailsForm.get(this.previousReferenceNumberFormControlName).clearValidators();
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).disable();
        }
        this.createApplicationService.propertyData = null;
        this.aflaModuleStrategyService.form.get("propertiesForm").reset();
        this.aflaModuleStrategyService.form.get("applicantForm").reset();
        this.aflaModuleStrategyService.form.get("professionalBodiesForm").reset();
        this.aflaModuleStrategyService.form.get("noteForm").reset();
    }
    onVerifyReferenceNumberClicked() {
        const previousReferenceNumber = this.detailsForm.get(this.previousReferenceNumberFormControlName).value;
        if (previousReferenceNumber !== null || previousReferenceNumber !== "") {
            if (this.isResubmission) {
                const params = {
                    previousReferenceNumber,
                    isResubmission: this.isResubmission,
                    moduleId: this.appController.selectedModuleID
                };
                this.buildingPlansService.verifyResubmissionReferenceNumberObservable(params).subscribe({
                    next: response => {
                        this.onVerifyComplete(response);
                    },
                    error: err => {
                        this.onVerifyError(err);
                    }
                });
            }
            else if (this.isExtension) {
                const params = {
                    previousReferenceNumber,
                    moduleId: this.appController.selectedModuleID
                };
                this.buildingPlansService.verifyExtensionReferenceNumberObservable(params).subscribe({
                    next: response => {
                        this.onVerifyComplete(response);
                    },
                    error: err => {
                        this.onVerifyError(err);
                    }
                });
            }
        }
    }
    onVerifyComplete(response) {
        if (response !== undefined && response !== null) {
            this.showDetails = true;
            this.aflaModuleStrategyService.previousApplication = response;
            this.onGetApplicationDetailsCompleted(response);
            this.getCompleteApplication();
            this.appController.showMessage(this.verificationMessage, AlertType.Success);
            this.isVerified = true;
            this.detailsForm.get("verified").setValue(this.isVerified);
            this.changeDetectorRefs.detectChanges();
        }
        else {
            this.appController.showMessage("Invalid previous application reference number provided", AlertType.Error);
        }
    }
    onVerifyError(err) {
        this.appController.handleServerErrorMessage(this.componentName, err, CRUDOperation.Selecting);
        this.showDetails = false;
        this.isVerified = false;
        this.detailsForm.get("verified").setValue(this.isVerified);
        this.changeDetectorRefs.detectChanges();
    }
    onGetApplicationDetailsCompleted(response) {
        this.detailsForm.get(this.descriptionFormControlName).setValue(response.description);
        this.detailsForm.get(this.buildingPlanNumberFormControlName).setValue(response.buildingPlanNumber);
        this.detailsForm.get(this.isMinorBuildingWorkFormControlName).setValue(response.isMinorBuildingWork);
        this.detailsForm.get(this.isResidentialApplicationFormControlName).setValue(response.isResidential);
        this.detailsForm.get(this.isAlterationsFormControlName).setValue(response.isAlterations);
        this.detailsForm.get(this.isRDPFormControlName).setValue(response.isRdp);
        this.detailsForm.get(this.estimatedCostFormControlName).setValue(response.applicationEstimatedCost);
        this.detailsForm.get(this.isBuildingUseOtherFormControlName).setValue(response.isBuildingUseOther);
        if (response.isResidential?.toLowerCase().trim() === "yes") {
            this.getBuildingUseFromResidentialBuildingUse();
        }
        if (response.isResidential?.toLowerCase().trim() === "no") {
            this.getBuildingUseFromNonResidentialBuildingUse();
        }
        this.buildingUseOptions.forEach(item => {
            if (item.value === response.buildingUse) {
                this.detailsForm.get(this.buildingUseFormControlName).setValue(item.value);
            }
        });
        if (response.buildingUse?.toLowerCase().trim() === "other") {
            this.otherApplicationIsSelected();
            this.detailsForm.get(this.buildingTypeFormControlName).setValue(response.buildingType);
        }
        else {
            this.detailsForm.get(this.buildingTypeFormControlName).clearValidators();
            this.detailsForm.get(this.buildingTypeFormControlName).updateValueAndValidity();
            this.showBuildingTypeField = false;
            this.detailsForm.get(this.isBuildingUseOtherFormControlName).setValue(response.isBuildingUseOther);
        }
        this.sectorOptions.forEach(item => {
            if (item.value === response.sector) {
                this.detailsForm.get(this.sectorFormControlName).setValue(item);
            }
        });
        this.applicationTypeOptions.forEach(item => {
            if (item.value === response.applicationType) {
                this.detailsForm.get(this.applicationTypeFormControlName).setValue(item);
            }
        });
        this.estimatedByOptions.forEach(item => {
            if (item.value === response.applicationEstimatedBy) {
                this.detailsForm.get(this.estimatedByFormControlName).setValue(item);
            }
        });
        this.detailsForm.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    getCompleteApplication() {
        const params = {
            $filter: `jobId eq ${this.aflaModuleStrategyService.previousApplication.jobId} and moduleId eq ${this.appController.selectedModuleID}`,
            $expand: `properties($expand=buildings,zonings,owners($expand=groups)),architect($expand=groups),engineer($expand=groups),electricalContractor($expand=groups),applicant($expand=groups),applicantAgent($expand=groups)`
        };
        this.aflaModuleStrategyService.getApplicationsQuery(params).pipe(takeUntil(this._destroy$), take(1)).subscribe((returnValue) => {
            const cleanedResult = this.cleanPreviousApplicationData(returnValue.value[0]);
            const result = cleanedResult;
            this.aflaModuleStrategyService.previousApplication = result;
            // set applicant form data
            if (result.applicant[0] !== null) {
                this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").setValue(result.applicant[0]);
            }
            // set applicantAgent form data
            this.aflaModuleStrategyService.form.get("applicantForm").get("markApplicantAgentAsNotApplicable").setValue(!result.applicantAgentNa);
            if (result.applicantAgent[0] !== null && result.applicantAgent.length !== 0) {
                this.aflaModuleStrategyService.form.get("applicantForm").get("applicantAgentRecipient").setValue(result.applicantAgent[0]);
                this.aflaModuleStrategyService.form.get("applicantForm").get("markApplicantAgentAsNotApplicable").setValue(true);
            }
            // set architect
            this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("markArchitectAsNotApplicable").setValue(!result.architectNa);
            if (result.architect[0] !== null && result.architect.length !== 0) {
                this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("architectRecipient").setValue(result.architect[0]);
                this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("markArchitectAsNotApplicable").setValue(true);
                this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("architectRecipient").enable();
            }
            // set engineer
            this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("markEngineerAsNotApplicable").setValue(!result.engineerNa);
            if (result.engineer[0] !== null && result.engineer.length !== 0) {
                this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("engineerRecipients").setValue(result.engineer[0]);
                this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("markEngineerAsNotApplicable").setValue(true);
                this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("engineerRecipients").enable();
            }
            // set Electrical Contractor
            this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("markElectricalContractorAsNotApplicable").setValue(!result.electricalContractorNa);
            if (result.electricalContractor[0] !== null && result.electricalContractor.length !== 0) {
                this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("electricalContractorRecipient").setValue(result.electricalContractor[0]);
                this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("markElectricalContractorAsNotApplicable").setValue(true);
                this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("electricalContractorRecipient").enable();
            }
            // set fireConsultant
            this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("markFireConsultantAsNotApplicable").setValue(!result.fireConsultantNa);
            if (result.fireConsultant !== null && result.fireConsultant !== undefined && result.fireConsultant[0] !== null && result.fireConsultant.length !== 0) {
                this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("fireConsultantRecipient").setValue(result.electricalContractor[0]);
                this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("markFireConsultantAsNotApplicable").setValue(true);
                this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("fireConsultantRecipient").enable();
            }
            // set Electrical Contractor
            this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("markOtherProfessionalAsNotApplicable").setValue(!result.otherProfessionalNa);
            if (result.otherProfessional !== null && result.otherProfessional !== undefined && result.otherProfessional[0] !== null && result.otherProfessional.length !== 0) {
                this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("otherProfessionalRecipient").setValue(result.electricalContractor[0]);
                this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("markOtherProfessionalAsNotApplicable").setValue(true);
                this.aflaModuleStrategyService.form.get("professionalBodiesForm").get("otherProfessionalRecipient").enable();
            }
            // set location
            this.createApplicationService.propertyData = result.properties[0];
        });
    }
    cleanPreviousApplicationData(application) {
        const app = {};
        if (application) {
            app.applicantAgentNa = application.applicantAgentNa;
            app.buildingPlanNumber = application.buildingPlanNumber;
            app.architectNa = application.architectNa;
            app.engineerNa = application.engineerNa;
            app.electricalContractorNa = application.electricalContractorNa;
            app.fireConsultantNa = application.fireConsultantNa;
            app.otherProfessionalNa = application.otherProfessionalNa;
            app.decision = application.decision;
            app.isMinorBuildingWork = application.isMinorBuildingWork;
            app.isResidential = application.isResidential;
            app.sector = application.sector;
            app.isRdp = application.isRdp;
            app.buildingUse = application.buildingUse;
            app.isBuildingUseOther = application.isBuildingUseOther;
            app.tpamsReferenceNumber = application.tpamsReferenceNumber;
            app.applicantAgentNa = application.applicantAgentNa;
            app.description = application.description;
            app.shape = application.shape;
            app.wkid = application.wkid;
            app.moduleId = application.moduleId;
            app.applicationType = application.applicationType;
            app.applicationEstimatedBy = application.applicationEstimatedBy;
            app.applicationEstimatedCost = application.applicationEstimatedCost;
        }
        if (application.properties) {
            let properties = {};
            properties = [];
            application.properties.forEach(p => {
                const property = {};
                property.id = 0;
                property.erfNumber = p.erfNumber;
                property.allotment = p.allotment;
                property.farmNumber = p.farmNumber;
                property.sgCode = p.sgCode;
                property.address = p.address;
                property.erfSize = p.erfSize;
                property.titleDeed = p.titleDeed;
                property.subdivision = p.subdivision;
                property.shape = p.shape;
                property.wkid = p.wkid;
                property.isDummy = p.isDummy;
                property.updateGeometry = p.updateGeometry;
                property.applicationDescription = p.applicationDescription;
                property.applicationRestrictions = p.applicationRestrictions;
                property.externalWalls = p.externalWalls;
                property.internalWalls = p.internalWalls;
                property.roofing = p.roofing;
                property.numberOfHouses = p.numberOfHouses;
                property.patioCoveredExisting = p.patioCoveredExisting;
                property.patioCoveredAdded = p.patioCoveredAdded;
                property.patioOpenExisting = p.patioOpenExisting;
                property.patioOpenAdded = p.patioOpenAdded;
                property.pool = p.pool;
                property.boundaryWallHeight = p.boundaryWallHeight;
                property.boundaryWallRunning = p.boundaryWallRunning;
                property.coverage = p.coverage;
                property.bulkCalculation = p.bulkCalculation;
                if (p.owners) {
                    let owners = {};
                    owners = [];
                    p.owners.forEach(o => {
                        const owner = {};
                        owner.clientVatNumber = o.clientVatNumber;
                        owner.setRecipient = o.setRecipient;
                        owner.fullName = o.fullName;
                        owner.id = 0;
                        owner.moduleId = o.moduleId;
                        owner.name = o.name;
                        owner.surname = o.surname;
                        owner.telephone = o.telephone;
                        owner.email = o.email;
                        owner.defaultCommunicationMethod = o.defaultCommunicationMethod;
                        owner.postalAddress = o.postalAddress;
                        owner.designation = o.designation;
                        owner.organisation = o.organisation;
                        owner.streetAddress = o.streetAddress;
                        owner.homePhone = o.homePhone;
                        owner.idNumber = o.idNumber;
                        owner.organisationRegistrationNumber = o.organisationRegistrationNumber;
                        owner.representative = o.representative;
                        owner.fax = o.fax;
                        owner.maritalStatus = o.maritalStatus;
                        owner.relativesFullName = o.relativesFullName;
                        owner.relativesContactNumber = o.relativesContactNumber;
                        owner.relativesAddress = o.relativesAddress;
                        owner.employmentStatus = o.employmentStatus;
                        owner.employersName = o.employersName;
                        owner.employersContactNumber = o.employersContactNumber;
                        owner.employersAddress = o.employersAddress;
                        owner.cellphone = o.cellphone;
                        owner.streetSuburb = o.streetSuburb;
                        owner.streetCity = o.streetCity;
                        owner.streetProvince = o.streetProvince;
                        owner.streetCode = o.streetCode;
                        owner.postalSuburb = o.postalSuburb;
                        owner.postalCity = o.postalCity;
                        owner.postalProvince = o.postalProvince;
                        owner.postalCode = o.postalCode;
                        owner.postalCountry = o.postalCountry;
                        owner.streetCountry = o.streetCountry;
                        owner.professionalBody = o.professionalBody;
                        owner.professionalBodyRegNum = o.professionalBodyRegNum;
                        owner.consolidatedGroup = o.consolidatedGroup;
                        owner.emailField = o.emailField;
                        let groups = {};
                        groups = [];
                        o.groups.forEach(g => {
                            const group = {};
                            group.groupName = g.groupName;
                            group.groupType = g.groupType;
                            groups.push(group);
                        });
                        owner.groups = groups;
                        /*     owner.groupsStringArray?: string[]; */
                        owners.push(owner);
                    });
                    property.owners = owners;
                }
                if (p.zonings) {
                    let zonings = {};
                    zonings = [];
                    p.zonings.forEach(z => {
                        const zone = {};
                        zone.zoning = z.zoning;
                        zonings.push(zone);
                    });
                    property.zonings = zonings;
                }
                if (p.buildings) {
                    let buildings = {};
                    buildings = [];
                    p.buildings.forEach(b => {
                        const building = {};
                        building.type = b.type;
                        building.floor = b.floor;
                        building.existingSize = b.existingSize;
                        building.addedSize = b.addedSize;
                        building.buildingNameNumber = b.buildingNameNumber;
                        buildings.push(building);
                    });
                    property.buildings = buildings;
                }
                properties.push(property);
            });
            app.properties = properties;
        }
        if (application.applicant) {
            let applicants = {};
            applicants = [];
            application.applicant.forEach(a => {
                const applicant = {};
                applicant.clientVatNumber = a.clientVatNumber;
                applicant.setRecipient = a.setRecipient;
                applicant.fullName = a.fullName;
                applicant.id = 0;
                applicant.moduleId = a.moduleId;
                applicant.name = a.name;
                applicant.surname = a.surname;
                applicant.telephone = a.telephone;
                applicant.email = a.email;
                applicant.defaultCommunicationMethod = a.defaultCommunicationMethod;
                applicant.postalAddress = a.postalAddress;
                applicant.designation = a.designation;
                applicant.organisation = a.organisation;
                applicant.streetAddress = a.streetAddress;
                applicant.homePhone = a.homePhone;
                applicant.idNumber = a.idNumber;
                applicant.organisationRegistrationNumber = a.organisationRegistrationNumber;
                applicant.representative = a.representative;
                applicant.fax = a.fax;
                applicant.maritalStatus = a.maritalStatus;
                applicant.relativesFullName = a.relativesFullName;
                applicant.relativesContactNumber = a.relativesContactNumber;
                applicant.relativesAddress = a.relativesAddress;
                applicant.employmentStatus = a.employmentStatus;
                applicant.employersName = a.employersName;
                applicant.employersContactNumber = a.employersContactNumber;
                applicant.employersAddress = a.employersAddress;
                applicant.cellphone = a.cellphone;
                applicant.streetSuburb = a.streetSuburb;
                applicant.streetCity = a.streetCity;
                applicant.streetProvince = a.streetProvince;
                applicant.streetCode = a.streetCode;
                applicant.postalSuburb = a.postalSuburb;
                applicant.postalCity = a.postalCity;
                applicant.postalProvince = a.postalProvince;
                applicant.postalCode = a.postalCode;
                applicant.postalCountry = a.postalCountry;
                applicant.streetCountry = a.streetCountry;
                applicant.professionalBody = a.professionalBody;
                applicant.professionalBodyRegNum = a.professionalBodyRegNum;
                applicant.consolidatedGroup = a.consolidatedGroup;
                applicant.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                applicant.groups = groups;
                /*      owner.groupsStringArray?: string[]; */
                applicants.push(applicant);
            });
            app.applicant = applicants;
        }
        if (application.applicantAgent) {
            let applicantAgents = {};
            applicantAgents = [];
            application.applicantAgent.forEach(a => {
                const applicantAgent = {};
                applicantAgent.clientVatNumber = a.clientVatNumber;
                applicantAgent.setRecipient = a.setRecipient;
                applicantAgent.fullName = a.fullName;
                applicantAgent.id = 0;
                applicantAgent.moduleId = a.moduleId;
                applicantAgent.name = a.name;
                applicantAgent.surname = a.surname;
                applicantAgent.telephone = a.telephone;
                applicantAgent.email = a.email;
                applicantAgent.defaultCommunicationMethod = a.defaultCommunicationMethod;
                applicantAgent.postalAddress = a.postalAddress;
                applicantAgent.designation = a.designation;
                applicantAgent.organisation = a.organisation;
                applicantAgent.streetAddress = a.streetAddress;
                applicantAgent.homePhone = a.homePhone;
                applicantAgent.idNumber = a.idNumber;
                applicantAgent.organisationRegistrationNumber = a.organisationRegistrationNumber;
                applicantAgent.representative = a.representative;
                applicantAgent.fax = a.fax;
                applicantAgent.maritalStatus = a.maritalStatus;
                applicantAgent.relativesFullName = a.relativesFullName;
                applicantAgent.relativesContactNumber = a.relativesContactNumber;
                applicantAgent.relativesAddress = a.relativesAddress;
                applicantAgent.employmentStatus = a.employmentStatus;
                applicantAgent.employersName = a.employersName;
                applicantAgent.employersContactNumber = a.employersContactNumber;
                applicantAgent.employersAddress = a.employersAddress;
                applicantAgent.cellphone = a.cellphone;
                applicantAgent.streetSuburb = a.streetSuburb;
                applicantAgent.streetCity = a.streetCity;
                applicantAgent.streetProvince = a.streetProvince;
                applicantAgent.streetCode = a.streetCode;
                applicantAgent.postalSuburb = a.postalSuburb;
                applicantAgent.postalCity = a.postalCity;
                applicantAgent.postalProvince = a.postalProvince;
                applicantAgent.postalCode = a.postalCode;
                applicantAgent.postalCountry = a.postalCountry;
                applicantAgent.streetCountry = a.streetCountry;
                applicantAgent.professionalBody = a.professionalBody;
                applicantAgent.professionalBodyRegNum = a.professionalBodyRegNum;
                applicantAgent.consolidatedGroup = a.consolidatedGroup;
                applicantAgent.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                applicantAgent.groups = groups;
                /*      owner.groupsStringArray?: string[]; */
                applicantAgents.push(applicantAgent);
            });
            app.applicantAgent = applicantAgents;
        }
        else {
            app.applicantAgentNa = true;
        }
        if (application.architect) {
            let architects = {};
            architects = [];
            application.architect.forEach(a => {
                const architect = {};
                architect.clientVatNumber = a.clientVatNumber;
                architect.setRecipient = a.setRecipient;
                architect.fullName = a.fullName;
                architect.id = 0;
                architect.moduleId = a.moduleId;
                architect.name = a.name;
                architect.surname = a.surname;
                architect.telephone = a.telephone;
                architect.email = a.email;
                architect.defaultCommunicationMethod = a.defaultCommunicationMethod;
                architect.postalAddress = a.postalAddress;
                architect.designation = a.designation;
                architect.organisation = a.organisation;
                architect.streetAddress = a.streetAddress;
                architect.homePhone = a.homePhone;
                architect.idNumber = a.idNumber;
                architect.organisationRegistrationNumber = a.organisationRegistrationNumber;
                architect.representative = a.representative;
                architect.fax = a.fax;
                architect.maritalStatus = a.maritalStatus;
                architect.relativesFullName = a.relativesFullName;
                architect.relativesContactNumber = a.relativesContactNumber;
                architect.relativesAddress = a.relativesAddress;
                architect.employmentStatus = a.employmentStatus;
                architect.employersName = a.employersName;
                architect.employersContactNumber = a.employersContactNumber;
                architect.employersAddress = a.employersAddress;
                architect.cellphone = a.cellphone;
                architect.streetSuburb = a.streetSuburb;
                architect.streetCity = a.streetCity;
                architect.streetProvince = a.streetProvince;
                architect.streetCode = a.streetCode;
                architect.postalSuburb = a.postalSuburb;
                architect.postalCity = a.postalCity;
                architect.postalProvince = a.postalProvince;
                architect.postalCode = a.postalCode;
                architect.postalCountry = a.postalCountry;
                architect.streetCountry = a.streetCountry;
                architect.professionalBody = a.professionalBody;
                architect.professionalBodyRegNum = a.professionalBodyRegNum;
                architect.consolidatedGroup = a.consolidatedGroup;
                architect.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                architect.groups = groups;
                /*      owner.groupsStringArray?: string[]; */
                architects.push(architect);
            });
            app.architect = architects;
        }
        else {
            app.architectNa = true;
        }
        if (application.engineer) {
            let engineers = {};
            engineers = [];
            application.engineer.forEach(a => {
                const engineer = {};
                engineer.clientVatNumber = a.clientVatNumber;
                engineer.setRecipient = a.setRecipient;
                engineer.fullName = a.fullName;
                engineer.id = 0;
                engineer.moduleId = a.moduleId;
                engineer.name = a.name;
                engineer.surname = a.surname;
                engineer.telephone = a.telephone;
                engineer.email = a.email;
                engineer.defaultCommunicationMethod = a.defaultCommunicationMethod;
                engineer.postalAddress = a.postalAddress;
                engineer.designation = a.designation;
                engineer.organisation = a.organisation;
                engineer.streetAddress = a.streetAddress;
                engineer.homePhone = a.homePhone;
                engineer.idNumber = a.idNumber;
                engineer.organisationRegistrationNumber = a.organisationRegistrationNumber;
                engineer.representative = a.representative;
                engineer.fax = a.fax;
                engineer.maritalStatus = a.maritalStatus;
                engineer.relativesFullName = a.relativesFullName;
                engineer.relativesContactNumber = a.relativesContactNumber;
                engineer.relativesAddress = a.relativesAddress;
                engineer.employmentStatus = a.employmentStatus;
                engineer.employersName = a.employersName;
                engineer.employersContactNumber = a.employersContactNumber;
                engineer.employersAddress = a.employersAddress;
                engineer.cellphone = a.cellphone;
                engineer.streetSuburb = a.streetSuburb;
                engineer.streetCity = a.streetCity;
                engineer.streetProvince = a.streetProvince;
                engineer.streetCode = a.streetCode;
                engineer.postalSuburb = a.postalSuburb;
                engineer.postalCity = a.postalCity;
                engineer.postalProvince = a.postalProvince;
                engineer.postalCode = a.postalCode;
                engineer.postalCountry = a.postalCountry;
                engineer.streetCountry = a.streetCountry;
                engineer.professionalBody = a.professionalBody;
                engineer.professionalBodyRegNum = a.professionalBodyRegNum;
                engineer.consolidatedGroup = a.consolidatedGroup;
                engineer.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                engineer.groups = groups;
                /*      owner.groupsStringArray?: string[]; */
                engineers.push(engineer);
            });
            app.engineer = engineers;
        }
        else {
            app.engineerNa = true;
        }
        if (application.electricalContractor) {
            let electricalContractors = {};
            electricalContractors = [];
            application.electricalContractor.forEach(a => {
                const electricalContractor = {};
                electricalContractor.clientVatNumber = a.clientVatNumber;
                electricalContractor.setRecipient = a.setRecipient;
                electricalContractor.fullName = a.fullName;
                electricalContractor.id = 0;
                electricalContractor.moduleId = a.moduleId;
                electricalContractor.name = a.name;
                electricalContractor.surname = a.surname;
                electricalContractor.telephone = a.telephone;
                electricalContractor.email = a.email;
                electricalContractor.defaultCommunicationMethod = a.defaultCommunicationMethod;
                electricalContractor.postalAddress = a.postalAddress;
                electricalContractor.designation = a.designation;
                electricalContractor.organisation = a.organisation;
                electricalContractor.streetAddress = a.streetAddress;
                electricalContractor.homePhone = a.homePhone;
                electricalContractor.idNumber = a.idNumber;
                electricalContractor.organisationRegistrationNumber = a.organisationRegistrationNumber;
                electricalContractor.representative = a.representative;
                electricalContractor.fax = a.fax;
                electricalContractor.maritalStatus = a.maritalStatus;
                electricalContractor.relativesFullName = a.relativesFullName;
                electricalContractor.relativesContactNumber = a.relativesContactNumber;
                electricalContractor.relativesAddress = a.relativesAddress;
                electricalContractor.employmentStatus = a.employmentStatus;
                electricalContractor.employersName = a.employersName;
                electricalContractor.employersContactNumber = a.employersContactNumber;
                electricalContractor.employersAddress = a.employersAddress;
                electricalContractor.cellphone = a.cellphone;
                electricalContractor.streetSuburb = a.streetSuburb;
                electricalContractor.streetCity = a.streetCity;
                electricalContractor.streetProvince = a.streetProvince;
                electricalContractor.streetCode = a.streetCode;
                electricalContractor.postalSuburb = a.postalSuburb;
                electricalContractor.postalCity = a.postalCity;
                electricalContractor.postalProvince = a.postalProvince;
                electricalContractor.postalCode = a.postalCode;
                electricalContractor.postalCountry = a.postalCountry;
                electricalContractor.streetCountry = a.streetCountry;
                electricalContractor.professionalBody = a.professionalBody;
                electricalContractor.professionalBodyRegNum = a.professionalBodyRegNum;
                electricalContractor.consolidatedGroup = a.consolidatedGroup;
                electricalContractor.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                electricalContractor.groups = groups;
                /*      owner.groupsStringArray?: string[]; */
                electricalContractors.push(electricalContractor);
            });
            app.electricalContractor = electricalContractors;
        }
        else {
            app.electricalContractorNa = true;
        }
        if (application.fireConsultant) {
            let fireConsultants = {};
            fireConsultants = [];
            application.fireConsultant.forEach(a => {
                const fireConsultant = {};
                fireConsultant.clientVatNumber = a.clientVatNumber;
                fireConsultant.setRecipient = a.setRecipient;
                fireConsultant.fullName = a.fullName;
                fireConsultant.id = 0;
                fireConsultant.moduleId = a.moduleId;
                fireConsultant.name = a.name;
                fireConsultant.surname = a.surname;
                fireConsultant.telephone = a.telephone;
                fireConsultant.email = a.email;
                fireConsultant.defaultCommunicationMethod = a.defaultCommunicationMethod;
                fireConsultant.postalAddress = a.postalAddress;
                fireConsultant.designation = a.designation;
                fireConsultant.organisation = a.organisation;
                fireConsultant.streetAddress = a.streetAddress;
                fireConsultant.homePhone = a.homePhone;
                fireConsultant.idNumber = a.idNumber;
                fireConsultant.organisationRegistrationNumber = a.organisationRegistrationNumber;
                fireConsultant.representative = a.representative;
                fireConsultant.fax = a.fax;
                fireConsultant.maritalStatus = a.maritalStatus;
                fireConsultant.relativesFullName = a.relativesFullName;
                fireConsultant.relativesContactNumber = a.relativesContactNumber;
                fireConsultant.relativesAddress = a.relativesAddress;
                fireConsultant.employmentStatus = a.employmentStatus;
                fireConsultant.employersName = a.employersName;
                fireConsultant.employersContactNumber = a.employersContactNumber;
                fireConsultant.employersAddress = a.employersAddress;
                fireConsultant.cellphone = a.cellphone;
                fireConsultant.streetSuburb = a.streetSuburb;
                fireConsultant.streetCity = a.streetCity;
                fireConsultant.streetProvince = a.streetProvince;
                fireConsultant.streetCode = a.streetCode;
                fireConsultant.postalSuburb = a.postalSuburb;
                fireConsultant.postalCity = a.postalCity;
                fireConsultant.postalProvince = a.postalProvince;
                fireConsultant.postalCode = a.postalCode;
                fireConsultant.postalCountry = a.postalCountry;
                fireConsultant.streetCountry = a.streetCountry;
                fireConsultant.professionalBody = a.professionalBody;
                fireConsultant.professionalBodyRegNum = a.professionalBodyRegNum;
                fireConsultant.consolidatedGroup = a.consolidatedGroup;
                fireConsultant.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                fireConsultant.groups = groups;
                /*      owner.groupsStringArray?: string[]; */
                fireConsultants.push(fireConsultant);
            });
            app.fireConsultant = fireConsultants;
        }
        else {
            app.fireConsultantNa = true;
        }
        if (application.otherProfessional) {
            let otherProfessionals = {};
            otherProfessionals = [];
            application.otherProfessional.forEach(a => {
                const otherProfessional = {};
                otherProfessional.clientVatNumber = a.clientVatNumber;
                otherProfessional.setRecipient = a.setRecipient;
                otherProfessional.fullName = a.fullName;
                otherProfessional.id = 0;
                otherProfessional.moduleId = a.moduleId;
                otherProfessional.name = a.name;
                otherProfessional.surname = a.surname;
                otherProfessional.telephone = a.telephone;
                otherProfessional.email = a.email;
                otherProfessional.defaultCommunicationMethod = a.defaultCommunicationMethod;
                otherProfessional.postalAddress = a.postalAddress;
                otherProfessional.designation = a.designation;
                otherProfessional.organisation = a.organisation;
                otherProfessional.streetAddress = a.streetAddress;
                otherProfessional.homePhone = a.homePhone;
                otherProfessional.idNumber = a.idNumber;
                otherProfessional.organisationRegistrationNumber = a.organisationRegistrationNumber;
                otherProfessional.representative = a.representative;
                otherProfessional.fax = a.fax;
                otherProfessional.maritalStatus = a.maritalStatus;
                otherProfessional.relativesFullName = a.relativesFullName;
                otherProfessional.relativesContactNumber = a.relativesContactNumber;
                otherProfessional.relativesAddress = a.relativesAddress;
                otherProfessional.employmentStatus = a.employmentStatus;
                otherProfessional.employersName = a.employersName;
                otherProfessional.employersContactNumber = a.employersContactNumber;
                otherProfessional.employersAddress = a.employersAddress;
                otherProfessional.cellphone = a.cellphone;
                otherProfessional.streetSuburb = a.streetSuburb;
                otherProfessional.streetCity = a.streetCity;
                otherProfessional.streetProvince = a.streetProvince;
                otherProfessional.streetCode = a.streetCode;
                otherProfessional.postalSuburb = a.postalSuburb;
                otherProfessional.postalCity = a.postalCity;
                otherProfessional.postalProvince = a.postalProvince;
                otherProfessional.postalCode = a.postalCode;
                otherProfessional.postalCountry = a.postalCountry;
                otherProfessional.streetCountry = a.streetCountry;
                otherProfessional.professionalBody = a.professionalBody;
                otherProfessional.professionalBodyRegNum = a.professionalBodyRegNum;
                otherProfessional.consolidatedGroup = a.consolidatedGroup;
                otherProfessional.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                otherProfessional.groups = groups;
                /*      owner.groupsStringArray?: string[]; */
                otherProfessionals.push(otherProfessional);
            });
            app.otherProfessional = otherProfessionals;
        }
        else {
            app.otherProfessionalNa = true;
        }
        return app;
    }
    getBuildingUseFromResidentialBuildingUse() {
        this.buildingUseOptions = [];
        this.detailsForm.get(this.buildingUseFormControlName).enable();
        this.buildingUseOptions = this.residentialBuildingUseOptions;
        this.aflaModuleStrategyService.lookups.set(this.buildingUseOptionsLookupName, this.buildingUseOptions);
        this.detailsForm.get(this.buildingTypeFormControlName).reset();
        this.showBuildingTypeField = false;
        this.detailsForm.get(this.isBuildingUseOtherFormControlName).setValue(false);
        this.detailsForm.updateValueAndValidity();
    }
    getBuildingUseFromNonResidentialBuildingUse() {
        this.buildingUseOptions = [];
        this.detailsForm.get(this.buildingUseFormControlName).enable();
        this.buildingUseOptions = this.nonResidentialBuildingUseOptions;
        this.aflaModuleStrategyService.lookups.set(this.buildingUseOptionsLookupName, this.buildingUseOptions);
        this.detailsForm.get(this.buildingTypeFormControlName).reset();
        this.showBuildingTypeField = false;
        this.detailsForm.get(this.isBuildingUseOtherFormControlName).setValue(false);
        this.detailsForm.updateValueAndValidity();
    }
    otherApplicationIsSelected() {
        this.detailsForm.get(this.isBuildingUseOtherFormControlName).setValue(true);
        this.detailsForm.get(this.buildingTypeFormControlName).addValidators(Validators.required);
        this.detailsForm.get(this.buildingTypeFormControlName).updateValueAndValidity();
        this.showBuildingTypeField = true;
    }
    isResidentialChanged($event) {
        const isResidential = $event.target.value;
        if (isResidential?.toLowerCase().trim() === "yes") {
            this.getBuildingUseFromResidentialBuildingUse();
        }
        if (isResidential?.toLowerCase().trim() === "no") {
            this.getBuildingUseFromNonResidentialBuildingUse();
        }
    }
    buildingUseChanged($event) {
        const buildingUseValue = $event.target.value;
        if (buildingUseValue?.toLowerCase().trim() === "other") {
            this.otherApplicationIsSelected();
        }
        else {
            this.detailsForm.get(this.buildingTypeFormControlName).clearValidators();
            this.detailsForm.get(this.buildingTypeFormControlName).updateValueAndValidity();
            this.showBuildingTypeField = false;
        }
        this.detailsForm.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    initialiseBuildingUseFields() {
        const otherBusinessUse = this.detailsForm.get(this.isBuildingUseOtherFormControlName).value;
        const buildingUse = this.detailsForm.get(this.buildingUseFormControlName).value;
        if (otherBusinessUse) {
            this.showBuildingTypeField = true;
        }
        else {
            this.showBuildingTypeField = false;
        }
        if (buildingUse) {
            this.detailsForm.get(this.buildingUseFormControlName).enable();
        }
        else {
            this.detailsForm.get(this.buildingUseFormControlName).disable();
        }
    }
    onToggleAccept(event) {
        if (!this.detailsForm.get("verified").value) {
            this.appController.showMessage("Please validate an application before accepting disclaimer", AlertType.Warning);
            this.detailsForm.get("acceptDisclaimer").setValue(false);
            return;
        }
        const accept = event.target.checked;
        this.detailsForm.get("acceptDisclaimer").setValue(accept);
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: BuildingPlansService }
    ];
};
CreateApplicationDetailsBpComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-details-bp",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsBpComponent);
export { CreateApplicationDetailsBpComponent };
